<script setup lang="ts"></script>

<template>
  <div class="grid-layout bg-ngray-6">
    <Suspense>
      <minimal-content-header />
    </Suspense>
    <main class="flex flex-col justify-center items-center w-full bg-ngray-7">
      <minimal-content-section>
        <slot />
      </minimal-content-section>
    </main>
  </div>
</template>
<style lang="postcss" scoped>
.grid-layout {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 3rem 1fr;
  overflow: auto;
}
header {
  grid-area: 1 / 1 / 2 / 2;
}
main {
  grid-area: 2 / 1 / 3 / 2;
  min-height: calc(100vh - 3rem);
}
</style>
